<template>
  <InformationTemplate ref="form" :form="form" :rules="rules" :radioTypeInfoText="radioTypeInfoText">
    <template #radio   v-if="!isIBT">
      <UploadTypeRadio
        prop="poaType"
        :label="$t(radioLabel)"
        :value="form.poaType"
        :options="poaTypeOptions"
        :onChange="option => (form.poaType = option)"
      />
    </template>
    <UploadTipInfo v-if="isIBT"/>
    <template #form>
      <FormRowContainer>
        <SelectForm
          class="showPlaceholder"
          v-model="form.countryId"
          :disabled="true"
          :label="$t('register.personalDetails.page2.mainResidency')"
          name="countryId"
        >
          <el-option
            v-for="(item, index) in countries"
            :key="index"
            :label="item.countryName"
            :value="item.id"
          ></el-option>
        </SelectForm>
        <InputForm
          :label="$t('register.personalDetails.page2.cityOrSuburb')"
          :placeholder="$t('register.personalDetails.page2.cityOrSuburb')"
          :disabled="disabled"
          class="showPlaceholder"
          name="suburb"
          maxlength="128"
          v-model="form.suburb"
        />
      </FormRowContainer>
      <FormRowContainer>
        <InputForm
          class="showPlaceholder"
          :label="$t('register.personalDetails.page2.address')"
          :placeholder="$t('register.personalDetails.page2.address')"
          :disabled="disabled"
          name="address"
          maxlength="256"
          v-model="form.address"
        />
        <div />
      </FormRowContainer>
    </template>
  </InformationTemplate>
</template>

<script>
import { mapState } from 'vuex';
import FormRowContainer from '../formRows/FormRowContainer.vue';
import InformationTemplate from './templates/InformationTemplate.vue';
import UploadTypeRadio from './components/UploadTypeRadio.vue';
import UploadTipInfo from './components/UploadTipInfo'
export default {
  name: 'PoaInformation',
  components: {
    FormRowContainer,
    InformationTemplate,
    UploadTypeRadio,
    UploadTipInfo
  },
  props: {
    radioLabel: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    radioTypeInfoText: { type: String, default: '' },
    isIBT: {type: Boolean, default: false}
  },
  data() {
    return {
      form: {
        countryId: null,
        address: '',
        suburb: '',
        poaType: null
      },
      rules: {
        countryId: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('common.formValidation.countryReq')
          }
        ],
        address: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('common.formValidation.addressReq')
          }
        ],
        suburb: [
          {
            required: true,
            trigger: 'blur',
            message: this.$t('common.formValidation.suburbReq')
          }
        ],
        poaType: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('verificationStatus.poaInformation.poaTypeIsRequired')
          }
        ]
      }
    };
  },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    },
    ...mapState('register', ['countries'])
  },
  watch: {
    lang() {
      this.$store.dispatch('register/getCountries', this.lang);
    }
  },
  created() {
    this.poaTypeOptions = [
      {
        value: 1,
        label: 'verificationStatus.poaInformation.utilityBill'
      },
      {
        value: 2,
        label: 'verificationStatus.poaInformation.bankStatement'
      },
      {
        value: 3,
        label: 'verificationStatus.poaInformation.other',
        infoText: `verificationStatus.poaInformation.otherInfoText`
      }
    ];
    this.form.poaType = this.isIBT ? 2 : this.poaTypeOptions[0].value;
  },
  mounted() {
    this.$store.dispatch('register/getCountries', this.lang);
  },
  methods: {
    validateField(props, callback) {
      this.$refs.form?.validateField(props, callback);
    },
    validate(callback) {
      this.$refs.form?.validate((valid, rules) => callback?.(valid, rules));
    },
    clearValidate(props) {
      this.$refs.form?.clearValidate(props);
    }
  }
};
</script>
